import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'

import vuetify from './plugins/vuetify'
import './plugins/youtube'
import './plugins/portal'
import './plugins/datetime-picker'
import './plugins/announcer'

import ColorPicker from '@/components/ColorPicker'
import MapInput from '@/components/MapInput'
import GalleryInput from '@/components/GalleryInput'
import './registerServiceWorker'

Vue.component('ColorPicker', ColorPicker)
Vue.component('MapInput', MapInput)
Vue.component('GalleryInput', GalleryInput)

Vue.config.productionTip = false

// console.log('welcome to: ' + process.env.VUE_APP_TITLE + ' on ' + process.env.NODE_ENV)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
